<div [formGroup]="form" class="form-group newpost-container">
  <label *ngIf="field?.label">{{ field.label }}{{ field.validation?.required ? '*' : '' }}</label>
  <app-info-icon
    [message]="field.infoIconMessage"
    *ngIf="field.infoIconMessage"
  ></app-info-icon>
  <div class="newpost-tab-content">
    <!-- new code -->
    <div *ngIf="!form.get(field.name)?.value" class="newpost-upload">
      <label
        (click)="filePicker1.click()"
        for="newpostUpload1"
        class="uploadFile upload-downloadable"
      >
        <input
          #filePicker1
          (change)="fileChangeEventOnAddVideoButton($event)"
          [attr.accept]="field?.allowedFileType || null"
          type="file"
          class="upload"
          id="filePicker1"
          appMobileBridgeFileInput
          [fileConfig]="{
            messageType: MOBILE_BRIDGE_EVENT_SEND.ALL_MEDIA_PICKER
          }"
        />
        <em>+</em>
        <span>{{field?.placeholder}}</span>
        <p class="extension" *ngIf="field?.featureLabels">{{field?.featureLabels}}</p>
      </label>
      <p class="extension" *ngIf="!field?.featureLabels">File size limit (100MB)</p>
    </div>
    <div *ngIf="form.get(field.name)?.value" class="newpost-upload-data">
      <div class="uploadContainer">
        <div
          *ngIf="showProgress || form.get(field.name)?.value"
          class="uploadFileImageData w-100"
        >
          <div class="show-progress-bar pointer-none" *ngIf="showProgress && cs.isBrowser">
            <circle-progress
              [percent]="percent"
              [radius]="23"
              [outerStrokeWidth]="3"
              [innerStrokeWidth]="3"
              [outerStrokeColor]="cs.isWhiteLabelWeb ? cs.whiteLabelData?.data?.whiteLabel?.theme_color : '#09c6da'"
              [innerStrokeColor]="'#47665f'"
              [animation]="false"
              [animationDuration]="300"
              [showSubtitle]="false"
              [backgroundPadding]="0"
              [titleFontSize]="10"
              [titleColor]="'#ffffff'"
              [unitsColor]="'#ffffff'"
              [space]="-3"
            ></circle-progress>
          </div>
          <div
            *ngIf="!showProgress && form.get(field.name)?.value"
            class="d-flex align-items-center justify-content-between h-100"
          >
            <div class="d-flex align-items-center gap-30px w-75">
              <div class="w-40px">
                <em class="icon-litedocument file-doc-em f-54px"></em>
              </div>
              <div class="text-ellipses">
                {{ displayFileName }}
              </div>
            </div>
            <div class="w-max-content">
              <em
                (click)="removeVideoFromVideos()"
                class="icon-delete-filled cursor-pointer"
              ></em>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-validation-errors
    [control]="form.get(field.name)"
    [field]="field"
  ></app-validation-errors>
</div>
